const formatAssessmentItemOption = ({ title, id }) => ({
  name: title,
  value: id,
});

export default formatAssessmentItemOption;
